import { Injectable } from '@angular/core';

@Injectable({
    providedIn: 'root'
})

export class DescriptionType {
    public types: any[] = [
        { id: 1, label: 'Zimmet', isSingle: false },
        { id: 2, label: 'Teslim Mail', isSingle: true }, // +
        { id: 3, label: 'Teklif Onay Maili', isSingle: true }, // +
        { id: 4, label: 'Teklif Ek Maili', isSingle: true }, // +
        { id: 5, label: 'Sertfika İleti', isSingle: true },  // +
        { id: 6, label: 'Teslim Maili', isSingle: true }, // +
        { id: 7, label: 'Süresi Yaklaşan Sertfika Maili', isSingle: true }, // +
        { id: 8, label: 'Anket Maili', isSingle: true }, // +

    ];

    descriptionTypes(id) {
        const result = this.types.find(p => p.id == id);
        return result?.label;
    }

    allType() {
        return this.types;
    }
}